// ContxtIQ marketing page — scroll animations, modal, nav

(function () {
  // ── Scroll animations ──
  function initScrollAnimations() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    const targets = document.querySelectorAll(
      ".mkt-fade-up, .mkt-fade-left, .mkt-fade-right, .mkt-fade-scale"
    );
    if (!targets.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("mkt-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    targets.forEach((el) => observer.observe(el));
  }

  // ── Active section in the nav ──
  // Marks whichever section currently owns the upper part of the viewport, so
  // the nav indicator tracks the reader instead of only reacting to clicks.
  function initSectionNav() {
    const links = Array.from(
      document.querySelectorAll('.mkt-nav__link[href^="#"]')
    );
    if (!links.length) return;

    const sections = new Map();
    links.forEach((link) => {
      const section = document.querySelector(link.getAttribute("href"));
      if (!section) return;
      if (!sections.has(section)) sections.set(section, []);
      sections.get(section).push(link);
    });
    if (!sections.size) return;

    let current = null;

    function activate(section) {
      if (section === current) return;
      current = section;
      links.forEach((link) => link.classList.remove("mkt-nav__link--active"));
      if (!section) return;
      sections.get(section).forEach((link) => {
        link.classList.add("mkt-nav__link--active");
      });
    }

    const observer = new IntersectionObserver(
      () => {
        // Pick the last section whose top has passed the nav. Reading position
        // beats intersection ratio here: tall sections would otherwise lose to
        // short ones that happen to be fully visible.
        const marker = 120;
        let active = null;
        sections.forEach((_, section) => {
          if (section.getBoundingClientRect().top <= marker) active = section;
        });
        activate(active);
      },
      { threshold: [0, 0.01, 0.5, 1], rootMargin: "-80px 0px 0px 0px" }
    );

    sections.forEach((_, section) => observer.observe(section));
    window.addEventListener(
      "scroll",
      () => {
        const marker = 120;
        let active = null;
        sections.forEach((_, section) => {
          if (section.getBoundingClientRect().top <= marker) active = section;
        });
        activate(active);
      },
      { passive: true }
    );
  }

  // ── Demo modal ──
  function initModal() {
    const backdrop = document.getElementById("demo-modal");
    if (!backdrop) return;

    function open() {
      // Reset form state on each open
      const f = document.getElementById("demo-form");
      const s = document.getElementById("demo-success");
      const err = document.getElementById("demo-error");
      const btn = document.getElementById("demo-submit");
      if (f) { f.reset(); f.hidden = false; }
      if (s) s.hidden = true;
      if (err) err.hidden = true;
      if (btn) { btn.disabled = false; btn.textContent = "Request a demo"; }

      backdrop.removeAttribute("hidden");
      requestAnimationFrame(() => {
        backdrop.classList.add("mkt-modal-active");
      });
      document.body.style.overflow = "hidden";
    }

    function close() {
      backdrop.classList.remove("mkt-modal-active");
      document.body.style.overflow = "";
      backdrop.addEventListener("transitionend", function handler() {
        backdrop.setAttribute("hidden", "");
        backdrop.removeEventListener("transitionend", handler);
      });
    }

    document.querySelectorAll("[data-demo-open]").forEach((btn) => {
      btn.addEventListener("click", open);
    });

    backdrop.addEventListener("click", (e) => {
      if (e.target === backdrop) close();
    });

    const closeBtn = backdrop.querySelector(".demo-modal-close");
    if (closeBtn) closeBtn.addEventListener("click", close);

    window.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && !backdrop.hasAttribute("hidden")) close();
    });

    const form = document.getElementById("demo-form");
    const submitBtn = document.getElementById("demo-submit");
    const errorEl = document.getElementById("demo-error");
    const successEl = document.getElementById("demo-success");

    if (form) {
      form.addEventListener("submit", async (e) => {
        e.preventDefault();
        errorEl.hidden = true;
        submitBtn.disabled = true;
        submitBtn.textContent = "Sending…";

        const body = new URLSearchParams(new FormData(form)).toString();
        const csrf = document.querySelector('meta[name="csrf-token"]');

        try {
          const res = await fetch("/demo_request", {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              "X-CSRF-Token": csrf ? csrf.content : "",
            },
            body,
          });

          if (res.ok) {
            form.hidden = true;
            successEl.hidden = false;
          } else {
            const data = await res.json().catch(() => ({}));
            errorEl.textContent = data.error || "Something went wrong. Please try again.";
            errorEl.hidden = false;
            submitBtn.disabled = false;
            submitBtn.textContent = "Request a demo";
          }
        } catch {
          errorEl.textContent = "Something went wrong. Please try again.";
          errorEl.hidden = false;
          submitBtn.disabled = false;
          submitBtn.textContent = "Request a demo";
        }
      });
    }
  }

  // ── Nav behavior ──
  function initNav() {
    const nav = document.getElementById("main-nav");
    if (!nav) return;

    window.addEventListener("scroll", () => {
      nav.classList.toggle("mkt-nav--scrolled", window.scrollY > 64);
    }, { passive: true });

    const hamburger = nav.querySelector(".mkt-nav__hamburger");
    if (hamburger) {
      hamburger.addEventListener("click", () => {
        nav.classList.toggle("mkt-nav--open");
        const expanded = nav.classList.contains("mkt-nav--open");
        hamburger.setAttribute("aria-expanded", expanded);
        hamburger.setAttribute("aria-label", expanded ? "Close menu" : "Open menu");
      });

      nav.querySelectorAll(".mkt-nav__mobile a, .mkt-nav__mobile button").forEach((link) => {
        link.addEventListener("click", () => {
          nav.classList.remove("mkt-nav--open");
          hamburger.setAttribute("aria-expanded", "false");
          hamburger.setAttribute("aria-label", "Open menu");
        });
      });
    }
  }

  // ── Init ──
  function boot() {
    initScrollAnimations();
    initSectionNav();
    initModal();
    initNav();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
